import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { SippApi } from '../../../services/SippExpress'
import {
  WaterTestKitRequest,
  WaterTestKitRequestsInitialState,
} from '../waterTestKitRequests.slice'

interface RequestOptions {
  id: string
  body: {
    home_age: string,
    systems: string[],
    refrigerator_brand: string,
    refrigerator_model: string,
  },
  options?: AxiosRequestConfig
}
export const updateWaterTestKitRequestAsync = createAsyncThunk<
  Partial<WaterTestKitRequest>[],
  RequestOptions
>('waterTestKits/updateById', async ({ id, options, body }, { rejectWithValue }) => {
  try {

    const response = (await SippApi.update.waterTestKitRequest( id, body ,options)) as AxiosResponse<
      Partial<WaterTestKitRequest>[]
    >

    return response.data
  } catch (err: any) {
    return rejectWithValue(
      err.response?.data || {
        message: 'Unexpected error occurred',
        errors: [],
      },
    )
  }
})

export const updateWaterTestKitRequestsBuilder = (
  builder: ActionReducerMapBuilder<WaterTestKitRequestsInitialState>,
) => {
  builder.addCase( updateWaterTestKitRequestAsync.pending, (state) => {
    state.loading = true
    state.error = false
  })
  builder.addCase( updateWaterTestKitRequestAsync.fulfilled, (state, action) => {
    state.loading = false
    state.error = false
    state.data = action.payload
  })
  builder.addCase( updateWaterTestKitRequestAsync.rejected, (state) => {
    state.loading = false
    state.error = true
  })
}
